export default "https://assets.egbcdn.net/assets/packs/_/images/svg_icons/app-hero-no-fill-7eb89eb75e423f5f6ca492863fff0aaa.svg";